import transV2Service from '@/services/formBuilder/transV2Service.js';

/**
 * Batch upload images/logos for form builder
 * API: POST /api/v1/clinic-charting/images/batch-upload
 * 
 * @param {Array<File>} files - Array of file objects to upload
 * @param {String} clinicId - Clinic ID from userInfo
 * @returns {Promise<Array>} - Array of { file_id: string, url?: string }
 */
export async function batchUploadImagesApi(files, clinicId) {
  try {
    const formData = new FormData();
    
    // Append clinic_id
    formData.append('clinic_id', clinicId);
    
    // Append all files to FormData
    files.forEach((file, index) => {
      formData.append('files', file);
    });
    
    const response = await transV2Service.post(
      '/api/v1/clinic-charting/images/batch-upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error batch uploading images:', error);
    throw new Error(error?.message ?? 'Failed to batch upload images');
  }
}

/**
 * Decrypt and fetch image/logo by file ID
 * API: GET /api/v1/clinic-charting/images/decrypt/:id
 * 
 * @param {String} fileId - File ID to fetch
 * @returns {Promise<Blob>} - Image blob
 */
export async function decryptImageApi(fileId) {
  try {
    const response = await transV2Service.get(
      `/api/v1/clinic-charting/images/decrypt/${fileId}`,
      {
        responseType: 'blob'
      }
    );
    
    return response.data;
  } catch (error) {
    console.error(`Error decrypting image ${fileId}:`, error);
    throw new Error(error?.message ?? 'Failed to decrypt image');
  }
}
